// extracted by mini-css-extract-plugin
module.exports = {"container":"cardContainer_container__1iY3U","cardTitle":"cardContainer_cardTitle__2z0yS"};